import { FC, useEffect, useState } from 'react';
import styled from 'styled-components';
import CustomButton from '../CustomButton/CustomButton';
import { ReactComponent as CrossIcon } from '../../../assets/icons/cross.svg';
import carImage from '../../../assets/images/popup/car.svg';

const NewYearPopup: FC = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        // Проверка дат: для локального тестирования с 11.12.2025, для продакшена с 15.12.2025 до 11.01.2026 включительно
        const startDate = new Date('2025-12-15T00:00:00'); // Для локального тестирования
        // const startDate = new Date('2025-12-15T00:00:00'); // Для продакшена
        const endDate = new Date('2026-01-11T23:59:59');
        const now = new Date();

        // Проверяем, находится ли текущая дата в диапазоне
        if (now >= startDate && now <= endDate) {
            // Получаем дату последнего показа (формат: YYYY-MM-DD)
            const lastShownDate = localStorage.getItem('newYearPopupShownDate');
            const today = new Date().toISOString().split('T')[0]; // Текущая дата в формате YYYY-MM-DD
            
            // Показываем попап, если он еще не был показан сегодня
            if (lastShownDate !== today) {
                // Задержка 5 секунд
                const timer = setTimeout(() => {
                    setIsVisible(true);
                }, 5000);

                return () => clearTimeout(timer);
            }
        }
    }, []);

    const handleClose = () => {
        setIsVisible(false);
        // Сохраняем текущую дату в формате YYYY-MM-DD
        const today = new Date().toISOString().split('T')[0];
        localStorage.setItem('newYearPopupShownDate', today);
        document.body.style.overflow = 'auto';
        document.body.style.paddingRight = '0';
    };

    // Блокируем скролл при открытии попапа
    useEffect(() => {
        if (isVisible) {
            document.body.style.overflow = 'hidden';
            document.body.style.paddingRight = '15px';
        }
    }, [isVisible]);

    if (!isVisible) return null;

    return (
        <StyledOverlay onClick={handleClose}>
            <StyledPopup onClick={(e) => e.stopPropagation()}>
                <StyledCloseButton onClick={handleClose}>
                    <CrossIcon />
                </StyledCloseButton>
                
                <StyledContent>
                    <StyledImageContainer>
                        <StyledImage 
                            src={carImage}
                            alt="Новогодние машинки"
                        />
                    </StyledImageContainer>
                    
                    <StyledTextContainer>
                        <StyledTitle>
                            Дорогие заказчики, обращаем ваше внимание на то, что на время Новогодних праздников и каникул, действует особый* прейскурант!
                        </StyledTitle>
                        <StyledSubtitle>
                            Уточняйте цены перед поездкой у диспетчера!
                        </StyledSubtitle>
                        <StyledPrice>
                            *стоимость от 1 050 ₽
                        </StyledPrice>
                    </StyledTextContainer>
                    
                    <StyledButtonContainer>
                        <CustomButton
                            onClick={handleClose}
                            variant="primary"
                            type="button"
                        >
                            Понятно
                        </CustomButton>
                    </StyledButtonContainer>
                </StyledContent>
            </StyledPopup>
        </StyledOverlay>
    );
};

const StyledOverlay = styled.div`
    position: fixed;
    inset: 0;
    z-index: 2000;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(5px);
`;

const StyledPopup = styled.div`
    position: relative;
    width: 539px;
    max-width: 90vw;
    max-height: 90vh;
    background: #1A7DE6;
    border-radius: 12px;
    box-shadow: 0px 10px 20px rgba(0, 100, 205, 0.12);
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 64px;
    gap: 48px;
    overflow-y: auto;

    @media (max-width: 640px) {
        padding: 48px 32px;
        gap: 32px;
    }
`;

const StyledCloseButton = styled.button`
    position: absolute;
    top: 20px;
    right: 20px;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    border: none;
    cursor: pointer;
    z-index: 10;
    
    svg {
        width: 24px;
        height: 24px;
        
        path {
            stroke: #FFFFFF;
        }
    }
    
    &:hover {
        opacity: 0.7;
    }
`;

const StyledContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 48px;
    width: 100%;

    @media (max-width: 640px) {
        gap: 32px;
    }
`;

const StyledImageContainer = styled.div`
    width: 352px;
    height: 195.04px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    @media (max-width: 640px) {
        width: 100%;
        max-width: 300px;
        height: auto;
    }
`;

const StyledImage = styled.img`
    width: 100%;
    height: 100%;
    object-fit: contain;
`;

const StyledTextContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    width: 100%;
    max-width: 411px;
`;

const StyledTitle = styled.h2`
    font-family: 'Noto Sans', sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 150%;
    text-align: center;
    color: #FFFFFF;
    margin: 0;

    @media (max-width: 640px) {
        font-size: 18px;
    }
`;

const StyledSubtitle = styled.p`
    font-family: 'Noto Sans', sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 150%;
    text-align: center;
    color: #FFFFFF;
    margin: 0;

    @media (max-width: 640px) {
        font-size: 16px;
    }
`;

const StyledPrice = styled.p`
    font-family: 'Noto Sans', sans-serif;
    font-style: normal;
    font-weight: 300;
    font-size: 16px;
    line-height: 150%;
    text-align: center;
    color: #FFFFFF;
    margin: 0;
`;

const StyledButtonContainer = styled.div`
    width: 174px;
    display: flex;
    justify-content: center;

    @media (max-width: 640px) {
        width: 100%;
    }
`;

export default NewYearPopup;

